import { config } from "../config/config";

/** BASE_URL + path with exactly one "/" between them (the API returns paths both with and without a leading slash). */
export const assetUrl = (path) => {
  if (!path) return undefined; // no src at all instead of ".../undefined"
  if (/^https?:\/\//i.test(path)) return path;
  return `${config.BASE_URL}/${String(path).replace(/^\/+/, "")}`;
};

/**
 * Pictures that fail once (flaky mobile network, a "//" in the path) get one more try instead of
 * leaving the alt text on the page. Installed once, for every <img> of the site.
 */
export const installImageRetry = () => {
  if (typeof window === "undefined" || window.__imgRetryInstalled) return;
  window.__imgRetryInstalled = true;
  window.addEventListener(
    "error",
    (event) => {
      const img = event.target;
      if (!img || img.tagName !== "IMG" || img.dataset.retried) return;
      if (!img.src || !img.src.startsWith(config.BASE_URL)) return;
      img.dataset.retried = "1";
      const fixed = img.src.replace(/^(https?:\/\/[^/]+)\/{2,}/, "$1/");
      setTimeout(() => {
        img.src = `${fixed}${fixed.includes("?") ? "&" : "?"}r=${Date.now()}`;
      }, 1200);
    },
    true
  );
};
